import { useContext, useEffect } from "react";
import { Content } from "./components/Content/Content";
import { LoadingContext } from "./context/LoadingContext";
import { Navigate, Route, Routes } from "react-router-dom";
import { customRoutes } from "./Routes";
import { CookieBar } from "./components/CookieBar/CookieBar";
function App() {
  const { loading, setLoading } = useContext(LoadingContext);

  useEffect(() => {
    setLoading(false);
  });

  return (
    <div className="site-wrapper">
      <div className={`loading-wrapper ${!loading && "done"}`}>
        <div className="loading-spinner" />
      </div>
      {!loading && (
        <Content>
          <Routes>
            {customRoutes.map((r) => (
              <Route
                key={r.name}
                path={r.path}
                exact={r.exact}
                element={r.element}
              />
            ))}

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Content>
      )}
    </div>
  );
}

export default App;
